<template>
  <section id="journal" :class="{ expanded: expanded }" >
    <p class="title">Journal</p>
    <div class="content">
      <ul>
        <Journal 
          v-for="journal in journals" 
          ref="journals"
          :key="journal.uid"
          :slug="journal.slug"
          :title="journal.title"
          :date="journal.published_at"
          :body="journal.cleanBody"
          @journalHovered="handleJournalHoverIn($event)"
          @journalUnhovered="handleJournalHoverOut($event)"
          @journalClicked="handleJournalClick($event)"
        />
      </ul>
    </div>
  </section>
</template>

<script>
import Journal from './Journal'
import { EventBus } from '../EventBus'

export default {
  name: "journals",
  props: [
    'journals',
  ],
  components: {
    Journal,
  },
  data() {
    return {
      expanded: false,
    }
  },
  created() {
  },
  mounted() {
    if (EventBus.$root.mobile) this.transitionDuration = 0
    const noScrollSection = this.$el.querySelector('.content')
    this.$el.addEventListener('wheel', (event) => {
      if (noScrollSection.scrollHeight > noScrollSection.clientHeight) {
        event.stopPropagation()
      }
    })
  },
  methods: { 
    handleJournalHoverIn(journal) {
      if (!this.somethingIsSelected()) {
        this.fadeEverything()
        journal.faded = false
        journal.hovered = true
      }
    },
    handleJournalHoverOut() {
      if (!this.somethingIsSelected()) {
        this.unfadeEverything()
        this.unHoverEverything()
      }
    },
    handleJournalClick(journal) {
      if (!journal.selected) {
        this.$emit('childClicked', 'journal')
        this.$router.push(this.$publicPath + 'journal/' + journal.slug)
      } else {
        this.$router.push(this.$publicPath)
      }
    },
    openJournal(journal) {
      this.unselectEverything()
      this.fadeEverything()
      if (!EventBus.$root.mobile) {
        this.expanded = true    
      }
      journal.faded = false
      journal.selected = true
      setTimeout(() => {
        journal.fadein = true
        setTimeout(() => {
          this.scrollToJournal(journal)
        }, 100)
      }, 300)
    },
    scrollToJournal(component) {
      let journalSection = document.querySelector('#journal .content')
      let item = component.$el
      let gap = EventBus.$root.mobile ? 127 : 141
      journalSection.scroll({
        top: item.offsetTop - gap,
        behavior: 'smooth'
      })
    },
    somethingIsSelected() {
      const selectedJournal = this.$refs.journals.find(j => j.selected == true)
      if (selectedJournal) return true
    },
    unfadeinEverything() {
      this.$refs.journals.forEach(journal => journal.fadein = false)
    },
    unselectEverything() {
      this.expanded = false
      this.$refs.journals.forEach(journal => journal.selected = false)
    },
    fadeEverything() {
      this.$refs.journals.forEach(journal => journal.faded = true)
    },
    unfadeEverything() {
      this.$refs.journals.forEach(journal => journal.faded = false)
    },
    unHoverEverything() {
      this.$refs.journals.forEach(journal => journal.hovered = false)
    },
  },
}
</script>

<style scoped>

#journal {
  transition: width 0.3s ease;
}
#journal.expanded {
  width: 550px;
}
#journal.expanded div.content ul:first-child {
  margin-bottom: 500px;
}
</style>